<!-- Start breadcrumb -->
<section class="innerpage__head {{className}}">
    <div class="container" >
        <ol class="breadcrumb" style="color: white;">
            <ng-content></ng-content>
        </ol>
    </div>
</section>
<!-- End breadcrumb -->